import React from "react";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../actions/Actions.js';


const BadgeOutput=(props)=>{
  return(
    <div style={{marginTop:5,marginRight:5,border:"1px solid #ccc",borderRadius:5,padding:"5px 5px 5px 10px",display:"inline-block",fontSize:13,backgroundColor:"#f0f0f0"}}>
      {props.value}
      <i style={{marginLeft:5,cursor:"pointer"}} onClick={props.onDelete} className="fas fa-times-circle"></i>
    </div>
  )
}

function getDateString(filterValue){
  let filters=filterValue.split(",");
  let startDate=new Date();
  let endDate=new Date();
  filters.forEach((filter)=>{
    if(filter[0]===">"){
      startDate=new Date(Date.UTC(filter.substr(1,4),filter.substr(5,2)-1));
    }
    else if(filter[0]==="<"){
      endDate=new Date(Date.UTC(filter.substr(1,4),filter.substr(5,2)-1));
    }
  })


  return(Number(startDate.getMonth()+1) +"/" + startDate.getFullYear() +" - " +Number(endDate.getMonth()+1) +"/" + endDate.getFullYear())

}

function FilterBadge(props){
  if(props.filterType?.type==="list"){
    let allFilterValues=props.filterValue.split(",");
    return(
      props.filterValue.split(",").map((x)=><BadgeOutput key={x} onDelete={()=>props.updateFilters(allFilterValues.filter((item)=>item!==x),props.filterKey)}  value={x}/>)
    );
  }
  else if(props.filterType?.type==="number"){
    return(
      <BadgeOutput onDelete={()=>props.updateFilters([],props.filterKey)} value={props.filterType.text + props.filterValue}/>
    );
  }
  else if(props.filterType?.type==="date"){
    return(
      <BadgeOutput onDelete={()=>props.updateFilters([],props.filterKey)} value={getDateString(props.filterValue)}/>
    );
  }
  else{
    return(null)
  }
}


export default connect(state => ({ filterObject:state.data.filterObject}), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(FilterBadge);
